import { render } from "./UnconditionalOfferDialog.vue?vue&type=template&id=2037cbd0&scoped=true"
import script from "./UnconditionalOfferDialog.vue?vue&type=script&lang=js"
export * from "./UnconditionalOfferDialog.vue?vue&type=script&lang=js"

import "./UnconditionalOfferDialog.vue?vue&type=style&index=0&id=2037cbd0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2037cbd0"]])

export default __exports__